import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { workflowBreadcrumb } from '../utils/telemetry';

/** Records route intent centrally; BrowserTracing supplies the corresponding timing span. */
export function RouteTelemetryObserver(): null {
  const location = useLocation();

  useEffect(() => {
    workflowBreadcrumb('navigation.viewed', {
      route: location.pathname,
    });
  }, [location.pathname]);

  return null;
}
